interface ProcessPasteTextResult {
  newValue: string
  cursorPosition: number
}

export const processPasteTextToInput = (
  input: HTMLInputElement,
  pasteText: string,
  currentText: string,
  maxLength?: number,
): ProcessPasteTextResult => {
  const { selectionStart, selectionEnd } = input

  return processPasteText(selectionStart ?? 0, selectionEnd ?? 0, pasteText, currentText, maxLength)
}

export const processPasteText = (
  selectionStart: number,
  selectionEnd: number,
  pasteText: string,
  currentText: string,
  maxLength?: number,
): ProcessPasteTextResult => {
  let newValue = `${currentText.slice(0, selectionStart || 0)}${pasteText}${currentText.slice(selectionEnd || 0)}`
  if (maxLength && newValue.length > maxLength) {
    newValue = newValue.slice(0, maxLength)
  }
  const cursorPosition = selectionStart! + pasteText.length

  return { newValue, cursorPosition }
}
